<template>
    <card :title="`${membro.nome} ${membro.sobrenome}`">
        <div>
            <button v-if='!membro.obra_referencia_enable' title='Não pode pegar obra de referência' class='btn btn-block btn-danger' @click='obraReferenciaEnable()'>Não pode pegar obra de referência</button>
            <button v-else class='btn btn-block btn-success' title='Pode pegar obra de referência' @click='obraReferenciaEnable()'>Pode pegar obra de referência</button>
        </div>
    </card>
</template>
<script>

import MembrosService from '../services/membros-service'
import OverlayService from '../services/overlay-service'

export default {
  props: {
    membro: Object
  },

  methods: {

    obraReferenciaEnable () {
      const value = !this.membro.obra_referencia_enable

      OverlayService.trigger('show', true)
      MembrosService.obraReferenciaEnable(this.membro.id, value)
        .then(response => response.data)
        .then(response => {
          this.membro.obra_referencia_enable = response.obra_referencia_enable
          OverlayService.trigger('show', false)
        }, er => {
          OverlayService.trigger('show', false)
          this.$alertify.error('Erro ao recuperar membros')
        })
    }

  }
}
</script>
<style>
    .label {
        cursor: pointer;
    }
</style>

